import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "container g-main__header" };
const _hoisted_2 = ["title"];
const _hoisted_3 = { class: "align-self-center flex-grow-1 ps-3 pe-3 d-none d-lg-flex" };
const _hoisted_4 = { class: "align-self-center d-flex" };
const _hoisted_5 = {
    key: 0,
    class: "nav-item nav-entry nav-entry__user"
};
const _hoisted_6 = { class: "d-flex" };
const _hoisted_7 = { class: "caption d-none d-xl-flex" };
const _hoisted_8 = { class: "text-muted" };
const _hoisted_9 = { class: "text" };
const _hoisted_10 = { class: "icon-container" };
const _hoisted_11 = ["title"];
const _hoisted_12 = { class: "content" };
const _hoisted_13 = {
    key: 1,
    class: "nav-item nav-entry nav-entry__user",
    style: { "padding-left": "0px" }
};
const _hoisted_14 = { class: "d-flex" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "caption d-none d-lg-flex" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "text-muted" }, "Kundenkonto"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-primary" }, "Jetzt anmelden...")
], -1);
const _hoisted_16 = { class: "icon-container" };
const _hoisted_17 = ["title"];
const _hoisted_18 = { class: "content" };
const _hoisted_19 = {
    key: 2,
    class: "nav-entry nav-entry__logout d-none d-sm-flex"
};
const _hoisted_20 = { class: "d-flex" };
const _hoisted_21 = { class: "icon-container" };
const _hoisted_22 = ["title"];
const _hoisted_23 = { class: "content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_logo = _resolveComponent("g-logo");
    const _component_router_link = _resolveComponent("router-link");
    const _component_g_ecommerce_box_search = _resolveComponent("g-ecommerce-box-search");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_ecommerce__account = _resolveComponent("g-ecommerce__account");
    const _component_g_ecommerce__carts = _resolveComponent("g-ecommerce__carts");
    const _component_g_ecommerce__request = _resolveComponent("g-ecommerce__request");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: "align-self-center mt-2 mb-2",
            title: _ctx.$host.config.title
        }, [
            _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                    _createVNode(_component_g_logo)
                ]),
                _: 1
            })
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_g_ecommerce_box_search)
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.hasUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$tc('client.Identity.Profile.Current')), 1),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.userDisplayName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_router_link, { to: "/service/profile" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: "icon",
                                        title: _ctx.$tc('client.Identity.Profile.Current') + ': ' + _ctx.userInitials
                                    }, [
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.userInitials), 1)
                                    ], 8, _hoisted_11)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_router_link, { to: "/login" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: "icon",
                                        title: _ctx.$tc('client.Identity.Profile.Current')
                                    }, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _createVNode(_component_g_icon, {
                                                width: "16",
                                                height: "16",
                                                src: "/assets/icons/person.svg",
                                                style: { "margin-bottom": "2px" }
                                            })
                                        ])
                                    ], 8, _hoisted_17)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ])),
            _createVNode(_component_g_ecommerce__account),
            _createVNode(_component_g_ecommerce__carts),
            _createVNode(_component_g_ecommerce__request),
            (_ctx.hasUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_router_link, { to: "/logout" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: "icon",
                                        title: _ctx.$tc('client.Common.Logout')
                                    }, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _createVNode(_component_g_icon, {
                                                width: "16",
                                                height: "16",
                                                src: "/assets/icons/box-arrow-right.svg",
                                                style: { "margin-bottom": "2px" }
                                            })
                                        ])
                                    ], 8, _hoisted_22)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
